export default __webpack_public_path__ + "static/media/place.c968e98d.svg";